// extracted by mini-css-extract-plugin
export var box = "_67-0";
export var check = "_67-1";
export var checkboxButton = "_67-6";
export var checkboxGroup = "_67-5";
export var disabled = "_67-7";
export var ghost = "_67-9";
export var input = "_67-2";
export var label = "_67-4";
export var normal = "_67-8";
export var uncheck = "_67-3";